export default function (nga, admin) {
    var BlacklistedAccount = admin.getEntity('BlacklistedAccount');

    BlacklistedAccount.listView()
        .title('<h4>Blacklisted Account <i class="fa fa-angle-right" aria-hidden="true"></i> List</h4>')
        .batchActions([])
        .fields([
            nga.field('username')
                .isDetailLink(false)
                .label('Username'),
            nga.field('customer_datum.firstname')
                .map(function (value, entry) {
                    return entry['customer_datum.firstname'] + ' ' + entry['customer_datum.lastname'];
                })
                .isDetailLink(false)
                .label('Name'),
            nga.field('is_blocked')
                .map(function (value, entry) {
                    return 'Blacklisted';
                })
                .isDetailLink(false)
                .label('Status'),
        ]);

    return BlacklistedAccount;

}



// WEBPACK FOOTER //
// ./js/BlacklistedAccount/config.js